import React from 'react';
import { Card, Table, Button, Tag, Space } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Shop } from '../../../services/supplyChainService';

interface StoreTableProps {
    shops: Shop[];
    loading: boolean;
    onAdd: () => void;
    onEdit: (record: Shop) => void;
    onDelete: (id: number) => void;
}

const StoreTable: React.FC<StoreTableProps> = ({ shops, loading, onAdd, onEdit, onDelete }) => {
    const columns = [
        {
            title: '店铺名称',
            dataIndex: 'name',
            key: 'name',
            render: (text: string) => <b>{text}</b>,
        },
        {
            title: '平台',
            dataIndex: 'platform',
            key: 'platform',
            render: (text: string) => <Tag color="blue">{text.toUpperCase()}</Tag>,
        },
        {
            title: '区域',
            dataIndex: 'region',
            key: 'region',
        },
        {
            title: '公司主体',
            dataIndex: 'company_name',
            key: 'company_name',
            render: (text: string) => text || '-',
        },
        {
            title: '卖家ID',
            dataIndex: 'seller_id',
            key: 'seller_id',
        },
        {
            title: '状态',
            dataIndex: 'is_active',
            key: 'is_active',
            render: (active: boolean) => (
                <Tag color={active ? 'green' : 'red'}>{active ? '启用' : '停用'}</Tag>
            ),
        },
        {
            title: '操作',
            key: 'action',
            render: (_: any, record: Shop) => (
                <Space size="middle">
                    <Button type="text" icon={<EditOutlined />} onClick={() => onEdit(record)} />
                    <Button type="text" danger icon={<DeleteOutlined />} onClick={() => onDelete(record.id!)} />
                </Space>
            ),
        },
    ];

    return (
        <Card title="店铺管理" extra={<Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>添加店铺</Button>}>
            <Table
                columns={columns}
                dataSource={Array.isArray(shops) ? shops : []}
                rowKey="id"
                loading={loading}
            />
        </Card>
    );
};

export default StoreTable;
